// Airports.js — SÜPER ADMIN: ORTAK MEYDAN LİSTESİ (adım M1, 30 Eyl 2026)
//
// 🔑 Serkan (30 Eyl): *"Airport database işini süper admine taşıyalım, aynı aircraft gibi; havalimanı
//    ekleme işini buradan yapalım, bütün kullanıcılar görsün"* · *"süper adminde elle meydan ekleme ve
//    database'i güncelleme olması lazım, aksi halde taşımak manasız."*
// M1: LİSTE + ARAMA · M3: + ADD AIRPORT (koordinattan saat dilimi + yaz/kış geçişleri gösterilir,
// GO2 resmi kaynakla kontrol edip onaylar — DST kararı "a"). Düzeltme/CLOSED (M4) ve OurAirports
// tazelemesi (M5) ayrı adımlar — kararlar hafıza `raaq-meydan-ekleme-akisi`. Yazma yolu ve iz:
// 20260930h (yalnız süper admin, gerekçe zorunlu, alan alan superadmin_log).
// Tablo `airports` KÜRESELDİR (~17 bin satır, OurAirports, 12 Tem 2026): FTL, FCL, OPS CALCULATOR,
// CZIB, arşiv ve iPad aynı satırı okur. 17 bin satır tarayıcıya ÇEKİLMEZ — arama ve sayım
// veritabanında yapılır (en çok 50 satır döner).
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { withReason } from '../editReason';
import HarfliGiris from './HarfliGiris';
import { ilkEksik, listedenAlan, dugmeStili } from './tasarim';   // alan listesi kapısı + zorunlu alan rengi (5 Eki 2026)
import { koordinattanDilim, dstMetni } from './dilimKontrolu';
import { aipOndalik, ondalikAip, koordinatGecerli, KOORDINAT_HATASI, KOORDINAT_ORNEK, KOORDINAT_SABLON } from './koordinat';
import { utcGun } from '../utcTarih';
import { RevizyonKurali, GecmisListesi, REVIZYON_EKSIK, gerekceliGuncelle } from './RevizyonUsulu';
import { SAYILI, hepsiniOku, okumaHataMetni } from './kesikOkuma';   // 24 ay şartı — kayıt geçmişi tam (6 Eki 2026)
import { GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // ortak gerekçe kuralı + satırı (21 Eki 2026, K7)

const C = {
  bg3:'var(--bg3)', border:'var(--border)', t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
  accent:'var(--accent)', red:'var(--red)',
};
const kutu = { width:'100%', boxSizing:'border-box', background:C.bg3, color:C.t1,
               border:`1px solid ${C.border}`, borderRadius:4, padding:'7px 9px',
               fontSize:12, fontFamily:'var(--mono)' };
const etiket = { display:'block', fontSize:9, color:C.t3, fontWeight:700, letterSpacing:1, marginBottom:4 };
const th = { textAlign:'left', padding:'7px 10px', fontSize:9, color:C.t3, fontWeight:700,
             letterSpacing:1, borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap' };
const td = { padding:'7px 10px', fontSize:12, color:C.t1, borderBottom:`1px solid ${C.border}`,
             fontFamily:'var(--mono)', verticalAlign:'top' };

export const MEYDAN_SINIR = 50;

// Arama metni PostgREST `or()` sözdizimine girer: virgül, parantez, nokta, yüzde sözdizimini
// bozar. Yalnız harf, rakam, boşluk ve tire kalır.
export const aramaTemizle = v => String(v || '').toUpperCase().replace(/[^A-Z0-9 -]/g, '').trim();

/** Arama filtresi: ICAO başı (en çok 4 harf/rakam ise) ya da adın içinde. */
export function meydanFiltresi(sorgu) {
  const q = aramaTemizle(sorgu);
  if (q.length < 2) return null;
  const parcalar = [`name.ilike.%${q}%`];
  if (/^[A-Z0-9]{2,4}$/.test(q)) parcalar.unshift(`icao.ilike.${q}%`);
  return parcalar.join(',');
}

// ── + ADD AIRPORT ────────────────────────────────────────────────────────────
// Ülke adı tarayıcıdan ("TR" → "Türkiye"); okunamazsa yalnız kod görünür, uydurulmaz.
const ulkeAdi = kod => {
  try { const ad = new Intl.DisplayNames(['en'], { type: 'region' }).of(kod); return ad && ad !== kod ? ad : ''; }
  catch { return ''; }
};
// Koordinat: AIP biçimi, bütün haneler (400741.16N / 0325942.35E) — çeviri ve kural TEK KAYNAK `koordinat.js` (Serkan 1 Eki, B).

/** Formun eksiği — veritabanının reddedeceğini ÖNCEDEN, adıyla söyler; yoksa null. */
// Rakım: tam sayı, feet (OurAirports ve havacılığın birimi). Boş = bilinmiyor, 0 DEĞİL.
export const rakimGecerli = v => v !== '' && v != null && Number.isInteger(Number(v));

// ALAN LİSTESİ (5 Eki 2026): kapı ilk geçersiz zorunlu alanın cümlesini söyler (`ilkEksik`), zorunlu alan rengi AYNI
// listeden (`listedenAlan`) — iPad kuralı. Sıra ve cümleler eskisiyle aynı.
const ortakMeydanAlanlari = (f, ulkeler, { rakimZorunlu, kontrolZorunlu }) => [
  { alan: 'name', zorunlu: true, gecerli: !!String(f.name || '').trim(), mesaj: 'Name is required.' },
  { alan: 'ulke', zorunlu: true, gecerli: ulkeler.includes(f.ulke), mesaj: 'Choose the country.' },
  { alan: 'lat', zorunlu: true, gecerli: koordinatGecerli(f.lat, 'lat'), mesaj: KOORDINAT_HATASI.lat },
  { alan: 'lon', zorunlu: true, gecerli: koordinatGecerli(f.lon, 'lon'), mesaj: KOORDINAT_HATASI.lon },
  { alan: 'elev', zorunlu: rakimZorunlu, gecerli: rakimGecerli(f.elev), mesaj: 'Elevation: a whole number of feet.' },
  { alan: 'tz', zorunlu: true, gecerli: !!f.tz, mesaj: 'Find the time zone from the coordinates.' },
  { alan: 'kontrol', zorunlu: kontrolZorunlu, gecerli: !!f.kontrol, mesaj: 'Confirm that you checked the time zone and the summer-time dates.' },
  { alan: 'reason', zorunlu: true, gecerli: gerekceTamam(f.reason), mesaj: gerekceIpucuMetni(f.reason) },
];
/** Ekleme formunun alanları. */
export const meydanEkleAlanlari = (f, { mevcut, ulkeler }) => [
  { alan: 'icao', zorunlu: true, gecerli: /^[A-Z]{4}$/.test(f.icao || ''), mesaj: 'ICAO code: 4 letters.' },
  { alan: 'icao', zorunlu: true, gecerli: !mevcut, mesaj: `${f.icao} is already in the airport list.` },
  ...ortakMeydanAlanlari(f, ulkeler, { rakimZorunlu: true, kontrolZorunlu: true }),
];
export function meydanFormHatasi(f, { mevcut, ulkeler }) {
  return ilkEksik(meydanEkleAlanlari(f, { mevcut, ulkeler }));
}

// Koordinat değişince bulunmuş dilim ve onay SIFIRLANIR — eski onay yeni koordinata taşınmaz.
const koordinatDegisti = setF => k => v => {
  setF(p => ({ ...p, [k]: v, tz: '', tzHata: null, kontrol: false }));
};

/** Koordinat kutusu — AIP biçimi; ekleme ve düzeltme formunda AYNI. Geçerliyse altında ondalık karşılığı görünür
 *  (veritabanındaki değer), geçersizse neyin beklendiği. `kayitli`: düzeltmede kutuya dokunulmadıysa KAYITLI hassas
 *  değer gösterilir (tam saniyeye yuvarlanmış metnin değeri değil — o gönderilmez de). */
function KoordinatKutusu({ f, eksen, onek, onChange, kayitli, alanlar = [] }) {
  const enlem = eksen === 'lat';
  const v = f[eksen];
  const dokunulmadi = typeof kayitli === 'number' && v === ondalikAip(kayitli, eksen);
  const d = dokunulmadi ? kayitli : aipOndalik(v, eksen);
  return (
    <div><label style={etiket}>{enlem ? 'LATITUDE * (AIP: DDMMSS.ss + N/S)' : 'LONGITUDE * (AIP: DDDMMSS.ss + E/W)'}</label>
      <HarfliGiris {...listedenAlan(alanlar, eksen, kutu)} data-testid={`${onek}-${enlem ? 'enlem' : 'boylam'}`} placeholder={KOORDINAT_SABLON[eksen]}
                   value={v} onChange={onChange} />
      <div data-testid={`${onek}-${enlem ? 'enlem' : 'boylam'}-ondalik`}
           style={{ fontSize:10, marginTop:3, fontFamily:'var(--mono)', color: isFinite(d) ? C.t3 : C.red }}>
        {v === '' ? '' : isFinite(d) ? `= ${d.toFixed(6)}°` : `e.g. ${KOORDINAT_ORNEK[eksen]}`}</div>
    </div>
  );
}

/** Saat dilimi + yaz/kış kontrolü — ekleme ve düzeltme formunda AYNI görünüm, AYNI kod. */
function DilimAlani({ f, setF, onek, alanlar = [] }) {
  const [araniyor, setAraniyor] = useState(false);
  const koordinatTamam = koordinatGecerli(f.lat, 'lat') && koordinatGecerli(f.lon, 'lon');
  const yil = new Date().getUTCFullYear();
  const bul = async () => {
    setAraniyor(true);
    const r = await koordinattanDilim(aipOndalik(f.lat, 'lat'), aipOndalik(f.lon, 'lon'));
    setAraniyor(false);
    setF(p => ({ ...p, tz: r.tz || '', tzHata: r.hata, kontrol: false }));
  };
  return (
    <div style={{ marginTop:12 }}>
      <label style={etiket}>TIME ZONE *</label>
      <div style={{ display:'flex', gap:10, alignItems:'center' }}>
        <button onClick={bul} disabled={!koordinatTamam || araniyor} data-testid={`${onek}-dilim-bul`}
                style={{ ...kutu, width:'auto', cursor: koordinatTamam ? 'pointer' : 'not-allowed' }}>
          {araniyor ? 'FINDING…' : 'FIND TIME ZONE'}</button>
        <span data-testid={`${onek}-dilim`} {...listedenAlan(alanlar, 'tz', { fontSize:12, fontFamily:'var(--mono)', padding:'4px 8px',
               borderRadius:6, color: f.tz ? C.accent : f.tzHata ? C.red : C.t3 })}>
          {f.tz || (f.tzHata ? `NOT FOUND — ${f.tzHata}` : 'from the coordinates')}</span>
      </div>
      {f.tz && (
        <div data-testid={`${onek}-dst`} style={{ marginTop:8, fontSize:11, color:C.t2, lineHeight:1.7 }}>
          <div><b>{yil}:</b> {dstMetni(f.tz, yil)}</div>
          <div><b>{yil + 1}:</b> {dstMetni(f.tz, yil + 1)}</div>
          {f.kontrolGerekli !== false && (
            <label data-testid={`${onek}-kontrol-kutu`}
                   {...listedenAlan(alanlar, 'kontrol', { display:'flex', gap:8, alignItems:'flex-start', marginTop:6, color:C.t1,
                                                          cursor:'pointer', padding:'6px 8px', borderRadius:6 })}>
              <input type="checkbox" data-testid={`${onek}-kontrol`} checked={f.kontrol}
                     onChange={e => { const v = e.target.checked; setF(p => ({ ...p, kontrol: v })); }} />
              <span>I checked this time zone and these summer-time dates against the official source.
                The dates come from this browser's time zone data; if the country has changed its rules
                recently, they may be out of date.</span>
            </label>
          )}
        </div>
      )}
    </div>
  );
}

const BOS_MEYDAN = { icao:'', name:'', ulke:'', lat:'', lon:'', elev:'', tz:'', tzHata:null, kontrol:false, reason:'' };

// Ülke listesi — ekleme ve düzeltme formu AYNI kaynaktan (meydan_ulkeleri(), 20260930i).
function useUlkeler() {
  const [ulkeler, setUlkeler] = useState({ liste: [], hata: null, yuklendi: false });
  useEffect(() => {
    let iptal = false;
    supabase.rpc('meydan_ulkeleri').then(({ data, error }) => {
      if (iptal) return;
      setUlkeler({ liste: (data || []).map(r => r.kod), hata: error ? error.message : null, yuklendi: true });
    });
    return () => { iptal = true; };
  }, []);
  return ulkeler;
}
const UlkeSecimi = ({ ulkeler, value, onChange, testId, alanlar = [] }) => (
  <select {...listedenAlan(alanlar, 'ulke', kutu)} data-testid={testId} value={value} onChange={e => onChange(e.target.value)}>
    <option value="">{ulkeler.yuklendi ? 'Choose' : 'Loading…'}</option>
    {ulkeler.liste.map(k => { const ad = ulkeAdi(k); return <option key={k} value={k}>{ad ? `${k} — ${ad}` : k}</option>; })}
  </select>
);

function MeydanEkleFormu({ toast, onKaydedildi, onKapat }) {
  const [f, setF] = useState(BOS_MEYDAN);
  const ulkeler = useUlkeler();
  const [mevcut, setMevcut] = useState(null);
  const [mevcutHata, setMevcutHata] = useState(null);   // "zaten var mı" okunamadı ≠ yok (21 Eki 2026)
  const [mevcutDeneme, setMevcutDeneme] = useState(0);
  const [kaydediyor, setKaydediyor] = useState(false);
  const alan = k => v => setF(p => ({ ...p, [k]: v }));
  const koordinat = koordinatDegisti(setF);

  useEffect(() => {
    if (!/^[A-Z]{4}$/.test(f.icao)) { setMevcut(null); setMevcutHata(null); return; }
    let iptal = false;
    // 🔴 21 Eki 2026 (W4b): hata okunmuyordu — düşen okuma "listede yok" sayılıp eklemeye izin veriyordu.
    supabase.from('airports').select('icao,name,source').eq('icao', f.icao).maybeSingle()
      .then(({ data, error }) => { if (iptal) return; setMevcutHata(error ? (error.message || String(error)) : null); setMevcut(error ? null : (data || null)); });
    return () => { iptal = true; };
  }, [f.icao, mevcutDeneme]);

  const hata = mevcutHata ? `Could not check whether ${f.icao} is already in the list — ${mevcutHata}`
    : !ulkeler.yuklendi ? 'Loading the country list…'
    : ulkeler.hata ? `Country list not read — ${ulkeler.hata}`
    : meydanFormHatasi(f, { mevcut, ulkeler: ulkeler.liste });
  // Zorunlu alan rengi — kapının AYNI listesinden (iPad kuralı, 5 Eki 2026).
  const alanlar = meydanEkleAlanlari(f, { mevcut, ulkeler: ulkeler.liste });

  const kaydet = async () => {
    if (hata) { toast(hata, 'error'); return; }
    setKaydediyor(true);
    let sb;
    try { sb = await withReason(f.reason.trim()); }
    catch (e) { setKaydediyor(false); toast(e.message, 'error'); return; }
    // source / ekleyen / zaman / gerekçe tetikleyicide yazılır (20260930h) — burada gönderilmez.
    const { error } = await sb.from('airports').insert({
      icao: f.icao, name: f.name.trim(), iso_country: f.ulke, lat: aipOndalik(f.lat, 'lat'), lon: aipOndalik(f.lon, 'lon'), tz: f.tz,
      elevation_ft: Number(f.elev),
    });
    setKaydediyor(false);
    if (error) { toast(error.message, 'error'); return; }
    toast(`${f.icao} added to the airport list — every company sees it now.`, 'success');
    onKaydedildi(f.icao);
  };

  return (
    <div data-testid="meydan-ekle-formu" style={{ border:`1px solid ${C.border}`, borderRadius:6, padding:14,
                                                   marginBottom:18, maxWidth:680, background:'var(--bg2)' }}>
      <div style={{ ...etiket, fontSize:10, color:C.accent }}>ADD AIRPORT</div>
      <div style={{ fontSize:10, color:C.t3, marginBottom:12, lineHeight:1.6 }}>
        The airport is added to the list every company uses. The row is saved in your name with the date and
        the reason; it is never deleted — a closed airport is marked CLOSED.
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        <div><label style={etiket}>ICAO *</label>
          <HarfliGiris {...listedenAlan(alanlar, 'icao', kutu)} data-testid="meydan-ekle-icao" placeholder="LTXX" maxLength={4}
                       value={f.icao} onChange={alan('icao')} />
          {mevcut && <div data-testid="meydan-ekle-mevcut" style={{ fontSize:10, color:C.red, marginTop:4 }}>
            {mevcut.icao} is already in the list: {mevcut.name} ({mevcut.source || 'OurAirports'}).</div>}</div>
        <div><label style={etiket}>COUNTRY *</label>
          <UlkeSecimi ulkeler={ulkeler} value={f.ulke} onChange={alan('ulke')} testId="meydan-ekle-ulke" alanlar={alanlar} /></div>
        <div style={{ gridColumn:'1 / -1' }}><label style={etiket}>NAME *</label>
          <HarfliGiris {...listedenAlan(alanlar, 'name', kutu)} data-testid="meydan-ekle-ad" placeholder="NEW AIRPORT"
                       value={f.name} onChange={alan('name')} /></div>
        <KoordinatKutusu f={f} eksen="lat" onek="meydan-ekle" onChange={koordinat('lat')} alanlar={alanlar} />
        <KoordinatKutusu f={f} eksen="lon" onek="meydan-ekle" onChange={koordinat('lon')} alanlar={alanlar} />
        <div><label style={etiket}>ELEVATION * (feet)</label>
          <input type="number" step="1" {...listedenAlan(alanlar, 'elev', kutu)} data-testid="meydan-ekle-rakim" placeholder="21"
                 value={f.elev} onChange={e => alan('elev')(e.target.value)} /></div>
      </div>

      <DilimAlani f={f} setF={setF} onek="meydan-ekle" alanlar={alanlar} />

      <div style={{ marginTop:12 }}><label style={etiket}>REASON *</label>
        <HarfliGiris as="textarea" {...listedenAlan(alanlar, 'reason', { ...kutu, minHeight:56, resize:'vertical' })} data-testid="meydan-ekle-gerekce"
                     placeholder="E.G. GO2DEMO FORM 01 OCT 2026 · AIP REFERENCE · REVISION MAIL 01 OCT"
                     value={f.reason} onChange={alan('reason')} /><GerekceIpucu metin={f.reason} testid="meydan-ekle-gerekce-ipucu" /></div>

      <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14, alignItems:'center' }}>
        {hata && <span data-testid="meydan-ekle-eksik" style={{ fontSize:10, color:C.t3, marginRight:'auto' }}>{hata}
          {mevcutHata && <button type="button" style={{ ...dugmeStili('notr'), marginLeft:6 }} onClick={() => setMevcutDeneme(n => n + 1)}>RETRY</button>}</span>}
        <button onClick={onKapat} style={{ ...kutu, width:'auto', cursor:'pointer' }}>CANCEL</button>
        <button onClick={kaydet} disabled={kaydediyor} data-testid="meydan-ekle-kaydet"
                style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1, cursor:'pointer',
                         color:'#08131f', background:C.accent, border:'none', borderRadius:4, fontFamily:'var(--mono)' }}>
          {kaydediyor ? 'SAVING…' : 'ADD AIRPORT'}</button>
      </div>
    </div>
  );
}

// ── DÜZELTME + CLOSED (adım M4) ──────────────────────────────────────────────
// 🔑 Serkan: *"ileride meydan adları değişecek … bir meydan kapanacak, ben onu elle kaldıracağım veya
//    adını değiştireceğim"* · *"CLOSED işaretlenmeli, oraya yapılmış arşivdeki uçuşlar etkilenebilir."*
// Yalnız DEĞİŞEN alan gönderilir; iz alan alan veritabanında yazılır (20260930h). ICAO değişmez.
// Koordinat ya da dilim değişirse dilim yeniden bulunur ve yeniden onaylanır (ekleme ile aynı kural).
const MEYDAN_KOLONLARI = 'icao,name,iso_country,lat,lon,elevation_ft,tz,source,added_by,added_at,added_reason,closed_at,closed_by,closed_reason';

/** Değişen alanlar — yalnız bunlar gönderilir. */
export function meydanDegisiklikleri(f, kayit) {
  const d = {};
  if (f.name.trim() !== (kayit.name || '')) d.name = f.name.trim();
  if (f.ulke !== (kayit.iso_country || '')) d.iso_country = f.ulke;
  // Koordinat: kutudaki metin kaydın gösterimiyle AYNIYSA gönderilmez — saniyenin yüzde birine yuvarlanmış gösterim,
  //    kayıtlı hassas değeri (40.128101) sessizce 40.1281'e çevirmesin.
  if (f.lat !== ondalikAip(kayit.lat, 'lat')) d.lat = aipOndalik(f.lat, 'lat');
  if (f.lon !== ondalikAip(kayit.lon, 'lon')) d.lon = aipOndalik(f.lon, 'lon');
  const rakim = (f.elev === '' || f.elev == null) ? null : Number(f.elev);
  if (rakim !== (kayit.elevation_ft ?? null)) d.elevation_ft = rakim;
  if (f.tz !== (kayit.tz || '')) d.tz = f.tz;
  return d;
}

/** Düzeltmenin eksiği; yoksa null. Dilim/koordinat değiştiyse onay şart. */
/** Düzeltme formunun alanları — rakım boş bırakılabilir (yazılmışsa geçerli olmalı); onay yalnız koordinat ya da dilim
 *  değişince istenir. */
export function meydanDuzeltAlanlari(f, kayit, ulkeler) {
  const d = meydanDegisiklikleri(f, kayit);
  return ortakMeydanAlanlari(f, ulkeler, { rakimZorunlu: f.elev !== '' && f.elev != null,
                                           kontrolZorunlu: 'lat' in d || 'lon' in d || 'tz' in d });
}
export function duzeltmeHatasi(f, kayit, ulkeler) {
  if (!Object.keys(meydanDegisiklikleri(f, kayit)).length) return 'Nothing changed.';
  return ilkEksik(meydanDuzeltAlanlari(f, kayit, ulkeler));
}

function MeydanDuzeltFormu({ icao, toast, onKaydedildi, onKapat }) {
  const ulkeler = useUlkeler();
  const [kayit, setKayit] = useState({ satir: null, hata: null, yuklendi: false });
  const [iz, setIz] = useState({ satirlar: [], hata: null });
  const [adlar, setAdlar] = useState({});
  const [adHata, setAdHata] = useState(null);
  const [f, setF] = useState(null);
  const [kaydediyor, setKaydediyor] = useState(false);
  // C·6c: değişiklik aylık revizyon listesinde duyurulmuş olmalı — işaretlenmeden hiçbir düğme çalışmaz.
  const [revizyon, setRevizyon] = useState(false);

  useEffect(() => {
    let iptal = false;
    (async () => {
      // 🔑 Ad çevirisi (20260930n): iz TEK özet satırı (row_id NAME_ENGLISH_LETTERS). Meydanın kendi geçmişinde de
      //    görünsün diye BU meydanın eski/yeni adı yedekten (20260930o: yalnız süper admin okur), gerekçe özet
      //    satırdan okunur ve geçmişe tek satır olarak eklenir.
      // 🔴 ÖNCESİ (Serkan 1 Eki, LTAC): HISTORY "No changes recorded — the row is as it came from OurAirports"
      //    diyordu; ad değişmişti.
      const [{ data, error }, izr, yedek, ozet] = await Promise.all([
        supabase.from('airports').select(MEYDAN_KOLONLARI).eq('icao', icao).maybeSingle(),
        // Kayıt geçmişi TAM (6 Eki 2026, 24 ay şartı 2d-2b): koda gömülü son 50 kalktı, parça parça; kesik okuma
        // "HISTORY NOT READ" olur (yarım geçmiş gösterilmez — Serkan A).
        hepsiniOku(() => supabase.from('superadmin_log').select('id,at,actor_id,op,field,old_value,new_value,reason', SAYILI)
          .eq('table_name', 'airports').eq('row_id', icao).order('at', { ascending: false })),
        supabase.from('airports_ad_yedek_20260930').select('name_eski,name_yeni,at').eq('icao', icao).maybeSingle(),
        supabase.from('superadmin_log').select('at,reason')
          .eq('table_name', 'airports').eq('row_id', 'NAME_ENGLISH_LETTERS').maybeSingle(),
      ]);
      if (iptal) return;
      setKayit({ satir: data || null, hata: error ? error.message : (data ? null : `${icao} was not found`), yuklendi: true });
      const adSatiri = yedek.data ? [{ at: ozet.data?.at || yedek.data.at, actor_id: null, op: 'UPDATE', field: 'name',
        old_value: yedek.data.name_eski, new_value: yedek.data.name_yeni, reason: ozet.data?.reason || '—' }] : [];
      const izHata = okumaHataMetni(izr) || (yedek.error || ozet.error)?.message || null;
      setIz({ satirlar: izHata ? [] : [...(izr.data || []), ...adSatiri].sort((x, y) => String(y.at).localeCompare(String(x.at))),
              hata: izHata });
      if (data) setF({ name: data.name || '', ulke: data.iso_country || '', lat: ondalikAip(data.lat, 'lat'),
                       lon: ondalikAip(data.lon, 'lon'), elev: data.elevation_ft == null ? '' : String(data.elevation_ft),
                       tz: data.tz || '', tzHata: null, kontrol: false, reason: '' });
      const idler = [...new Set([data?.added_by, data?.closed_by, ...(izr.data || []).map(r => r.actor_id)].filter(Boolean))];
      if (!idler.length) return;
      const { data: p, error: pErr } = await supabase.from('profiles').select('id,code,full_name').in('id', idler);
      if (iptal) return;
      // 21 Eki 2026 (W4b): ad okunamazsa kimlik çıplak gösterilmez, söylenir — AIRCRAFT TYPES listesinin deseni.
      setAdHata(pErr ? (pErr.message || String(pErr)) : null);
      const h = {}; (p || []).forEach(x => { h[x.id] = [x.code, x.full_name].filter(Boolean).join(' — '); });
      setAdlar(h);
    })();
    return () => { iptal = true; };
  }, [icao]);

  if (!kayit.yuklendi) return <div style={{ fontSize:10, color:C.t3, marginBottom:14 }}>LOADING {icao}…</div>;
  if (kayit.hata) return <div data-testid="meydan-duzelt-hata" style={{ fontSize:12, color:C.red, fontWeight:700, marginBottom:14 }}>
    {icao} NOT READ — {kayit.hata}</div>;

  const k = kayit.satir;
  const kim = id => (id ? (adHata ? `(name not read — ${adHata})` : (adlar[id] || id)) : '—');
  const alan = a => v => setF(p => ({ ...p, [a]: v }));
  const koordinat = koordinatDegisti(setF);
  const degisti = meydanDegisiklikleri(f, k);
  // Dilim ya da koordinat değişmediyse kayıtlı dilim için yeniden onay İSTENMEZ.
  const dilimF = { ...f, kontrolGerekli: 'lat' in degisti || 'lon' in degisti || 'tz' in degisti };
  const hata = !ulkeler.yuklendi ? 'Loading the country list…'
    : ulkeler.hata ? `Country list not read — ${ulkeler.hata}` : duzeltmeHatasi(f, k, ulkeler.liste);
  const kapali = !!k.closed_at;
  const eksik = hata || (!revizyon ? REVIZYON_EKSIK : null);
  // Zorunlu alan rengi — kapının AYNI listesinden (iPad kuralı, 5 Eki 2026).
  const alanlarD = meydanDuzeltAlanlari(f, k, ulkeler.liste);

  const yaz = async (degisiklik, basari) => {
    setKaydediyor(true);
    // Tek yol (RevizyonUsulu): gerekçe istekle gider; dönen satır yoksa "kaydedildi" DENMEZ.
    const { hata: yazmaHatasi } = await gerekceliGuncelle({ tablo: 'airports', anahtarKolon: 'icao', anahtar: icao,
      etiket: icao, degisiklik, gerekce: f.reason });
    setKaydediyor(false);
    if (yazmaHatasi) { toast(yazmaHatasi, 'error'); return; }
    toast(basari, 'success');
    onKaydedildi(icao);
  };
  const kaydet = () => { if (eksik) { toast(eksik, 'error'); return; } yaz(degisti, `${icao} corrected.`); };
  const kapatAc = () => {
    if (!gerekceTamam(f.reason)) { toast(gerekceIpucuMetni(f.reason), 'error'); return; }
    if (!revizyon) { toast(REVIZYON_EKSIK, 'error'); return; }
    // Planlamada engel (FTL) AYRI adımdır — burada "planlanamaz" DENMEZ, henüz doğru değil.
    const soru = kapali
      ? `Reopen ${icao}? The CLOSED mark is removed.`
      : `Close ${icao}? It stays in the list marked CLOSED; flights already flown there are not affected.`;
    if (!window.confirm(soru)) return;
    // Kapanış anı, kapatan ve gerekçe TETİKLEYİCİDE yazılır; buradaki zaman yalnız "kapat" işaretidir.
    yaz({ closed_at: kapali ? null : new Date().toISOString() }, kapali ? `${icao} reopened.` : `${icao} closed.`);
  };

  return (
    <div data-testid="meydan-duzelt-formu" style={{ border:`1px solid ${C.border}`, borderRadius:6, padding:14,
                                                     marginBottom:18, maxWidth:680, background:'var(--bg2)' }}>
      <div style={{ ...etiket, fontSize:10, color:C.accent }}>EDIT AIRPORT — {icao}</div>
      <div data-testid="meydan-duzelt-kunye" style={{ fontSize:10, color:C.t3, marginBottom:12, lineHeight:1.7 }}>
        ICAO {icao} cannot be changed — past records are linked to it. Source: {k.source || 'OurAirports'}
        {k.added_by && <> · added by {kim(k.added_by)} · {utcGun(k.added_at)} · reason: {k.added_reason}</>}
        {kapali && <div data-testid="meydan-duzelt-kapali" style={{ color:C.red, fontWeight:700 }}>
          CLOSED since {utcGun(k.closed_at)} by {kim(k.closed_by)} — {k.closed_reason}</div>}
      </div>
      <RevizyonKurali onay={revizyon} setOnay={setRevizyon} testId="meydan-duzelt-revizyon" />
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        <div style={{ gridColumn:'1 / -1' }}><label style={etiket}>NAME *</label>
          <HarfliGiris {...listedenAlan(alanlarD, 'name', kutu)} data-testid="meydan-duzelt-ad" value={f.name} onChange={alan('name')} /></div>
        <div><label style={etiket}>COUNTRY *</label>
          <UlkeSecimi ulkeler={ulkeler} value={f.ulke} onChange={alan('ulke')} testId="meydan-duzelt-ulke" alanlar={alanlarD} /></div>
        <div><label style={etiket}>ELEVATION (feet)</label>
          <input type="number" step="1" {...listedenAlan(alanlarD, 'elev', kutu)} data-testid="meydan-duzelt-rakim" value={f.elev}
                 onChange={e => alan('elev')(e.target.value)} /></div>
        <KoordinatKutusu f={f} eksen="lat" onek="meydan-duzelt" onChange={koordinat('lat')} kayitli={k.lat} alanlar={alanlarD} />
        <KoordinatKutusu f={f} eksen="lon" onek="meydan-duzelt" onChange={koordinat('lon')} kayitli={k.lon} alanlar={alanlarD} />
      </div>
      <DilimAlani f={dilimF} setF={setF} onek="meydan-duzelt" alanlar={alanlarD} />
      <div style={{ marginTop:12 }}><label style={etiket}>REASON * (for a correction, a closure or a reopening)</label>
        <HarfliGiris as="textarea" {...listedenAlan(alanlarD, 'reason', { ...kutu, minHeight:56, resize:'vertical' })} data-testid="meydan-duzelt-gerekce"
                     placeholder="E.G. REV 2026-10 · AIP AMDT 10/26" value={f.reason} onChange={alan('reason')} /><GerekceIpucu metin={f.reason} testid="meydan-duzelt-gerekce-ipucu" /></div>

      <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14, alignItems:'center' }}>
        {eksik && <span data-testid="meydan-duzelt-eksik" style={{ fontSize:10, color:C.t3, marginRight:'auto' }}>{eksik}</span>}
        <button onClick={kapatAc} disabled={kaydediyor} data-testid="meydan-duzelt-kapat"
                style={{ ...kutu, width:'auto', cursor:'pointer', color: kapali ? C.accent : C.red,
                         borderColor: kapali ? C.accent : C.red }}>
          {kapali ? 'REOPEN AIRPORT' : 'CLOSE AIRPORT'}</button>
        <button onClick={onKapat} style={{ ...kutu, width:'auto', cursor:'pointer' }}>CANCEL</button>
        <button onClick={kaydet} disabled={kaydediyor} data-testid="meydan-duzelt-kaydet"
                style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1, cursor:'pointer',
                         color:'#08131f', background:C.accent, border:'none', borderRadius:4, fontFamily:'var(--mono)' }}>
          {kaydediyor ? 'SAVING…' : 'SAVE CHANGES'}</button>
      </div>

      <div style={{ ...etiket, marginTop:18 }}>HISTORY</div>
      <GecmisListesi satirlar={iz.satirlar} hata={iz.hata} kim={kim} testId="meydan-duzelt-iz"
                     bosMetni={`No changes recorded — the row is as it came from ${k.source || 'OurAirports'}.`} />
    </div>
  );
}

export default function Airports({ toast = () => {} }) {
  const [ozet, setOzet] = useState({ yuklendi: false, hata: null, toplam: 0, tzYok: 0, ulkeYok: 0, go2: 0, kapali: 0, rakimYok: 0 });
  // 🔑 Rakım doldurma düğmesi KALDIRILDI (Serkan 30 Eyl: *"o butona gerek var mı?"* → *"bence de a"*): 16 bin meydan
  //    bir kez dolduruldu; kalanlar OurAirports'ta da rakımsız → düğme 0 dolduruyordu ama görünmeye devam ediyordu.
  //    Eksik rakım EDIT'ten elle girilir (AIP); OurAirports'ta sonradan çıkanı aylık kontrol (U4, C·6c) yakalar —
  //    tek yöntem. Sunucu tarafı (`airports-refresh` · `fill_elevation`) U4'ün adımı olarak durur.
  const [sorgu, setSorgu] = useState('');
  const [sonuc, setSonuc] = useState({ satirlar: [], hata: null, araniyor: false });
  const [ekle, setEkle] = useState(false);
  const [duzelt, setDuzelt] = useState(null);
  const [yenile, setYenile] = useState(0);

  const ozetOku = useCallback(async (iptalMi = () => false) => {
    const say = q => q.select('icao', { count: 'exact', head: true });
    const [t, z, u, g, c, r] = await Promise.all([
      say(supabase.from('airports')),
      say(supabase.from('airports')).is('tz', null),
      say(supabase.from('airports')).is('iso_country', null),
      say(supabase.from('airports')).eq('source', 'GO2'),
      say(supabase.from('airports')).not('closed_at', 'is', null),
      say(supabase.from('airports')).is('elevation_ft', null),
    ]);
    if (iptalMi()) return;
    const hata = [t, z, u, g, c, r].map(x => x.error?.message).find(Boolean) || null;
    setOzet({ yuklendi: true, hata, toplam: t.count || 0, tzYok: z.count || 0, ulkeYok: u.count || 0,
              go2: g.count || 0, kapali: c.count || 0, rakimYok: r.count || 0 });
  }, []);

  useEffect(() => {
    let iptal = false;
    ozetOku(() => iptal);
    return () => { iptal = true; };
  }, [ozetOku, yenile]);

  useEffect(() => {
    const filtre = meydanFiltresi(sorgu);
    if (!filtre) { setSonuc({ satirlar: [], hata: null, araniyor: false }); return; }
    let iptal = false;
    setSonuc(s => ({ ...s, araniyor: true }));
    supabase.from('airports').select('icao,name,iso_country,lat,lon,elevation_ft,tz,source,closed_at')
      .or(filtre).order('icao').limit(MEYDAN_SINIR + 1)
      .then(({ data, error }) => {
        if (iptal) return;
        setSonuc({ satirlar: data || [], hata: error ? error.message : null, araniyor: false });
      });
    return () => { iptal = true; };
  }, [sorgu, yenile]);

  const { satirlar, hata, araniyor } = sonuc;
  const aramaVar = !!meydanFiltresi(sorgu);

  return (
    <div style={{ flex:1, overflowY:'auto', padding:18, minWidth:0 }}>
      {!ozet.yuklendi && <div style={{ fontSize:10, color:C.t3 }}>LOADING...</div>}
      {ozet.yuklendi && ozet.hata && (
        <div data-testid="meydan-ozet-hata" style={{ fontSize:12, color:C.red, fontWeight:700, marginBottom:12 }}>
          AIRPORT LIST NOT READ — {ozet.hata}
        </div>
      )}
      {ozet.yuklendi && !ozet.hata && (
        <div data-testid="meydan-ozet" style={{ fontSize:11, color:C.t2, marginBottom:14, lineHeight:1.7 }}>
          {ozet.toplam} airports · {ozet.tzYok} without a time zone · {ozet.ulkeYok} without a country · {ozet.rakimYok} without an elevation · {ozet.go2} added by GO2 · {ozet.kapali} closed
          <div style={{ fontSize:10, color:C.t3 }}>
            One shared list for every company, from OurAirports. FTL, FCL limits, OPS CALCULATOR, CZIB, the
            flight archive and the iPad all read the same row: the time zone gives local times, the
            coordinates give day and night.
          </div>
        </div>
      )}

      {duzelt
        ? <MeydanDuzeltFormu key={duzelt} icao={duzelt} toast={toast} onKapat={() => setDuzelt(null)}
                             onKaydedildi={() => { setDuzelt(null); setYenile(n => n + 1); }} />
        : ekle
        ? <MeydanEkleFormu toast={toast} onKapat={() => setEkle(false)}
                           onKaydedildi={icao => { setEkle(false); setYenile(n => n + 1); setSorgu(icao); }} />
        : <button onClick={() => setEkle(true)} data-testid="meydan-ekle"
                  style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1, cursor:'pointer',
                           color:'#08131f', background:C.accent, border:'none', borderRadius:4,
                           fontFamily:'var(--mono)', marginBottom:14 }}>+ ADD AIRPORT</button>}

      <label style={etiket}>SEARCH AIRPORT</label>
      <HarfliGiris style={{ ...kutu, maxWidth:420 }} data-testid="meydan-arama" value={sorgu}
                   placeholder="LTFE, BODRUM, GENEVA …" onChange={setSorgu} />
      <div style={{ marginTop:12 }}>
        {!aramaVar
          ? <div style={{ fontSize:10, color:C.t3 }}>Type an ICAO code or part of the name (at least 2 characters).</div>
          : hata
          ? <div data-testid="meydan-arama-hata" style={{ fontSize:12, color:C.red, fontWeight:700 }}>SEARCH FAILED — {hata}</div>
          : araniyor && !satirlar.length
          ? <div style={{ fontSize:10, color:C.t3 }}>SEARCHING...</div>
          : !satirlar.length
          ? <div data-testid="meydan-yok" style={{ fontSize:11, color:C.t2 }}>No airport matches “{aramaTemizle(sorgu)}”.</div>
          : (
            <>
              <table style={{ width:'100%', borderCollapse:'collapse' }} data-testid="meydan-tablo">
                <thead><tr>{['ICAO','NAME','COUNTRY','LAT','LON','ELEV (FT)','TIME ZONE',`UTC / DST ${new Date().getUTCFullYear()}`,'SOURCE'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
                <tbody>{satirlar.slice(0, MEYDAN_SINIR).map(m => (
                  <tr key={m.icao}>
                    <td style={{ ...td, fontWeight:700 }}>
                      <button onClick={() => { setEkle(false); setDuzelt(m.icao); }} data-testid={`meydan-duzelt-ac-${m.icao}`}
                              title="Edit or close this airport"
                              style={{ background:'none', border:'none', padding:0, cursor:'pointer', color:C.accent,
                                       fontWeight:700, fontFamily:'var(--mono)', fontSize:12, textDecoration:'underline' }}>
                        {m.icao}</button></td>
                    <td style={td}>{m.name || '—'}
                      {m.closed_at && <span data-testid="meydan-kapali-rozet" style={{ marginLeft:8, fontSize:9, fontWeight:700,
                        letterSpacing:1, color:C.red, border:`1px solid ${C.red}`, borderRadius:3, padding:'1px 5px' }}>CLOSED</span>}</td>
                    <td style={td}>{m.iso_country || <span style={{ color:C.red }}>NOT SET</span>}</td>
                    <td style={td}>{ondalikAip(m.lat, 'lat') || '—'}</td>
                    <td style={td}>{ondalikAip(m.lon, 'lon') || '—'}</td>
                    <td style={td}>{m.elevation_ft != null ? m.elevation_ft : <span style={{ color:C.red }}>NOT SET</span>}</td>
                    <td style={td}>{m.tz || <span style={{ color:C.red }}>NOT SET</span>}</td>
                    {/* Dilimden HESAPLANIR, saklanmaz — ADD AIRPORT formundaki metnin AYNISI (dstMetni, tek kaynak). */}
                    <td style={{ ...td, fontSize:10, color:C.t2, maxWidth:260 }}>{m.tz ? dstMetni(m.tz, new Date().getUTCFullYear()) : '—'}</td>
                    <td style={td}>{m.source || 'OurAirports'}</td>
                  </tr>
                ))}</tbody>
              </table>
              {satirlar.length > MEYDAN_SINIR && (
                <div data-testid="meydan-fazla" style={{ fontSize:10, color:C.t3, marginTop:6 }}>
                  More than {MEYDAN_SINIR} matches — refine the search.
                </div>
              )}
            </>
          )}
      </div>
    </div>
  );
}
